
import { getEnvironments } from '@/environments'
import { Component, Prop, Vue } from 'vue-property-decorator'
const env = getEnvironments()
const baseImg: string = env.url.IMG ? env.url.IMG : window.location.origin
@Component
export default class PeligroColorBar extends Vue {
  @Prop()
  private ruta!: string;
  @Prop()
  private colorBar!: string;

  get src () {
    return `${baseImg}/${this.ruta}/${this.colorBar}`
  }
}
